<template>
  <section data-testid="main-visual-section">
    <div class="relative h-[100svh]">
      <div class="h-[100svh]">
        <OrganismsPagesEnTopMainVisualSlider class="h-full" />
      </div>
      <div class="absolute inset-0 z-[1] flex w-full flex-col items-center justify-center">
        <div class="mb-4 md:mb-6 md:mt-[120px]">
          <img class="h-auto w-56 md:w-96" src="@/assets/logo/wabunka/ghost.svg" />
        </div>
        <p class="mt-4 w-full text-center font-Spectral text-[16px] leading-6 tracking-normal text-white md:text-[17px]">
          Pull back the curtain on the real Japan with <br class="md:hidden" />
          exclusive private tours, curated stays, and expert-led experiences.
        </p>
        <MoleculesLinkWithLine class="relative mr-5 mt-3 md:mt-8" :view-more-url="ABOUT_LP_URL">Our Story</MoleculesLinkWithLine>
      </div>
      <div class="absolute bottom-0 z-[1] flex w-full flex-col items-center">
        <div class="mb-4 w-full max-w-[480px] px-6 md:mb-8 md:p-0">
          <button class="flex h-[46px] w-full items-center bg-white px-4" data-testid="search-button" @click="onClickSearch">
            <AtomsSearchIcon /><span class="ml-3 text-base font-light leading-tight text-gold3">Search</span>
          </button>
        </div>
        <div class="mb-2 cursor-pointer pb-8 text-center" @click="onClickScroll">
          <div class="mb-2 text-[16px] leading-5 text-white">Scroll</div>
          <div class="-mb-[9px] ml-8 h-[0px] w-8 origin-top-left rotate-90 border-[0.5px] border-stone-100"></div>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts" setup>
import { ABOUT_LP_URL } from '@/wabunka-src/constants/aboutLp';
import { useKeywordSearchModal } from '@/wabunka-src/features/Search/composables/general/useKeywordSearchModal';

interface Props {
  scrollToPickUp: () => void;
}
const props = defineProps<Props>();

const { open } = useKeywordSearchModal();

const onClickSearch = () => {
  open();
};

const onClickScroll = () => {
  props.scrollToPickUp();
};
</script>
